import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * Guards a route behind:
 *   - a logged-in user (always required)
 *   - optionally an existing goal + roadmap (requireGoal=true)
 *
 * When requireGoal is set and the user has no active_goal_id / roadmap,
 * we bounce them to /onboarding instead of rendering a broken page.
 */
export default function ProtectedRoute({ children, requireGoal = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  if (requireGoal && !user.active_goal_id && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
